import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PingService {
  url: string = "https://cors-test.appspot.com/test";

  constructor(private _http: HttpClient) {}

  pingNow() {
    let timeStart: number = performance.now();
    return this._http.get(this.url).pipe(
      map((data) => {
        let timeEnd: number = performance.now();
        let ping: number = timeEnd - timeStart;
        return ping;
      }),
      catchError((error) => {
        // Return a default high ping value to indicate slow/failed connection
        console.warn('Ping service error:', error);
        return of(1000);
      })
    );
  }
}
